import { Basket } from '@modules/checkout-store';
import { IBasketItemWithDescription } from './basket-item-with-description.interface';

export interface IBasketWithDescriptions extends Basket {
  basketItems: IBasketItemWithDescription[];
}
